import * as React from 'react';
const SvgGreatContent = (props) => (
  <svg viewBox="0 0 127 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#great-content_svg__a)"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M25.797 58V40c13.25-1.395 30.277-.97 37.703 14 7.427-14.97 24.453-15.395 37.703-14v18M33.734 101.04c11.098.38 23.262 3.72 29.766 14.96 6.504-11.24 18.668-14.585 29.766-14.96M63.5 66v50" />
      <path d="M101.203 114c-17.86-10-37.703 2-37.703 2s-19.844-12-37.703-2M25.797 50l-9.922 2v6M101.203 50l9.922 2v6" />
      <path d="M21.828 118H12.73c-.526 0-1.032-.21-1.404-.585L7.937 114H3.97a1.992 1.992 0 0 1-1.985-2V74c0-1.105.888-2 1.985-2h3.969l3.378-5.11c.367-.555.987-.89 1.652-.89h8.86c2.193 0 3.969 1.79 3.969 4v44c0 2.21-1.776 4-3.969 4ZM11.906 102v16M105.172 118h9.098c.526 0 1.032-.21 1.404-.585l3.388-3.415h3.969a1.992 1.992 0 0 0 1.985-2V74c0-1.105-.888-2-1.985-2h-3.969l-3.378-5.11a1.981 1.981 0 0 0-1.652-.89h-8.86c-2.193 0-3.969 1.79-3.969 4v44c0 2.21 1.776 4 3.969 4ZM115.094 102v16" />
      <path d="M5.953 72V60C5.953 28.1 31.85 2 63.5 2c31.65 0 57.547 26.1 57.547 58v12" />
      <path d="M37.862 22c7.322-5.045 16.153-8 25.638-8 9.555 0 18.45 3 25.797 8.11" />
    </g>
    <defs>
      <clipPath id="great-content_svg__a">
        <path fill="#fff" d="M0 0h127v120H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGreatContent;
